'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _recompose = require('recompose');

var _ToolButton = require('../../../../components/buttons/ToolButton');

var _ToolButton2 = _interopRequireDefault(_ToolButton);

var _Icon = require('../../../../components/icons/Icon');

var _Icon2 = _interopRequireDefault(_Icon);

var _ExportPopup = require('./ExportPopup');

var _ExportPopup2 = _interopRequireDefault(_ExportPopup);

var _popupActions = require('../../../../components/popupPanel/popupActions');

require('./ExportUtil.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Actions
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        openPopupPanel: function openPopupPanel() {
            return dispatch((0, _popupActions.togglePopup)('export'));
        }
    };
};

// Components
// Lib


var ExportUtil = function ExportUtil(props) {
    var openPopupPanel = props.openPopupPanel;


    return _react2.default.createElement(
        'div',
        { className: 'ExportUtil' },
        _react2.default.createElement(_ToolButton2.default, { onClickFn: openPopupPanel, icon: _react2.default.createElement(_Icon2.default, { name: 'nav-export' }), text: 'Export' }),
        _react2.default.createElement(_ExportPopup2.default, props)
    );
};

ExportUtil.propTypes = {
    openPopupPanel: _propTypes2.default.func,
    activeUserCount: _propTypes2.default.number
};

var enhance = (0, _recompose.compose)((0, _reactRedux.connect)(null, mapDispatchToProps), _recompose.pure);

exports.default = enhance(ExportUtil);


//////////////////
// WEBPACK FOOTER
// ./src/client/workspace/header/utils/export/ExportUtil.js
// module id = 2178
// module chunks = 0